<template>
    <div v-if="callerComp && callerComp === 'MobileHeader'">
        <div class="px-2">
          <label class="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" value="" class="sr-only peer" @change="userRoleHandler" :checked="localUser && localUser.user_type && localUser.user_type === 2">
            <div class="w-11 h-6 bg-gray-400 rounded-full peer 
            peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 
            dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white
             after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white
              after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 
              after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
            <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{{localUser && localUser.user_type && localUser.user_type === 2 ? 'Seen as Trainer' : 'Seen as Attendee'}}</span>
          </label>
        </div>
    </div>
    <div class="relative ml-8" v-else v-click-outside="onoutsideAsTrainer">
        <button
            class="inline-flex items-center h-10 px-3 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none hover:bg-white ring-1 ring-gray-400 w-48 justify-center"
            @click="onclickAsTrainer"
        >
            <span>{{localUser && localUser.user_type && localUser.user_type === 2 ? 'Seen as Trainer' : 'Seen as Attendee'}}</span>
            <svg class="w-4 h-4 ml-3 fill-current" viewBox="0 0 20 20">
            <path
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
                fill-rule="evenodd"
            ></path>
            </svg>
        </button>
        <div
            class="absolute left-0 z-40 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray-400 ring-opacity-5 focus:outline-none"
            v-if="isAsTrainer"
        >
            <div class="py-1">
            <button
            type="button"
                class="text-gray-700 block w-full px-4 py-2 text-left text-sm hover:bg-gray-100"
                @click="switchToAttendeeProfile"
            >
                Seen as Attendee
            </button>
            <button
                type="button"
                class="text-gray-700 block w-full px-4 py-2 text-left text-sm hover:bg-gray-100"
                @click="switchToTrainerProfile"
            >
               Seen as Trainer
            </button>
            </div>
        </div>
    </div>
    
</template>
<script>
import {mapGetters} from "vuex";
import ClickOutside from "vue-click-outside";
    export default {
        data () {
            return {
                isAsTrainer: false,
                localUser: JSON.parse(localStorage.getItem("user")),
            }
        },
        props: [
          'callerComp'
        ],
        directives: {
            ClickOutside,
        },
        computed: {
            ...mapGetters([
                "getRoles",
            ]),
        },
        methods: {
            onoutsideAsTrainer() {
                this.isAsTrainer = false;
            },
            onclickAsTrainer() {
                this.isAsTrainer = !this.isAsTrainer;
            },
            async switchToTrainerProfile() {
                this.callerComp && this.callerComp === 'MobileHeader' ? this.$emit('switchProfile') : ''
                this.$store.commit("setIsLoading", true);
                await this.$store.dispatch('switchToTrainer').then(() => {
                    this.$router.replace({ name: "dashboard" });
                    this.$store.commit("setIsLoading", false);
                }) 
            },
            switchToAttendeeProfile () {
                this.callerComp && this.callerComp === 'MobileHeader' ? this.$emit('switchProfile') : ''
                this.$store.commit("setIsLoading", true);
                try {
                    this.$store.dispatch('switchToUser');
                    let user = JSON.parse(localStorage.getItem("user"));
                    user.user_type = 1;
                    localStorage.setItem("user", JSON.stringify(user));
                    const self = this
                    setTimeout(function () {
                        self.$router.replace({ name: "Newhome" });
                    }, 100)
                } catch {
                    console.log("Can't switch to Attendee profile");
                }
                this.$store.commit("setIsLoading", false);
            },
            userRoleHandler () {
                if ( this.localUser && this.localUser.user_type && this.localUser.user_type === 2) {
                    this.switchToAttendeeProfile();
                } else {
                    this.switchToTrainerProfile();
                }
            }
        },
        created() {
            if ( this.getToken() && this.localUser && this.localUser.user_type != this.GUEST && this.localUser.user_type === 1) {
                this.$store.dispatch('getUserRoles');
            }
        }
    }
</script>
<style>
</style>